import { useToast } from "@chakra-ui/react";
import axios from "axios";
import ForgotPasswordForm from "components/Organismos/ForgotPasswordForm";
import FormModalTemplate from "components/Templates/FormModal";
import { ForgotPasswordFormData } from "models/password-reset.model";
import { forgotPasswordRequest } from "store/modules/users/actions/forgotPassword";
import { useDispatchToPromise } from "utils/dispatch-to-promise";
import { useQueryParam } from "utils/hooks/useQueryParam";

const ForgotPasswordPage = () => {
    const [showForgotPassword, setShowForgotPassword] = useQueryParam<boolean>('showForgotPassword');
    const toast = useToast();
    const dispatchAsPromise = useDispatchToPromise();

    const closeModal = () => {
        setShowForgotPassword(false);
    }

    const handleSubmit = async (data: ForgotPasswordFormData) => {
        await dispatchAsPromise(forgotPasswordRequest, { cpf: data.cpf });
        toast({
            status: 'success',
            description: 'Foi enviado um e-mail para seu e-mail cadastrado.'
        });
    }

    const handleFailed = (err: unknown) => {
        if (axios.isAxiosError(err)) {
            if (err.response?.data.usuario && Array.isArray(err.response.data.usuario)) {
                toast({
                    status: 'warning',
                    description: err.response.data.usuario.join('\n')
                });
            } else {
                toast({
                    status: 'warning',
                    description: 'Erro ao entrar no sistema.'
                });
            }
        }
    }

    return (
        <FormModalTemplate
            form={(
                <ForgotPasswordForm
                    onSuccess={handleSubmit}
                    onFailed={handleFailed}
                />
            )}
            isOpenModal={String(showForgotPassword) === 'true'}
            onCloseModal={closeModal}
        />
    )
}
export default ForgotPasswordPage